import React from 'react';
import {DescriptionBox, DescriptionContent} from './style';

export default (props) => {
	const {icon, color, title, description} = props;
	
	return (
		<DescriptionBox color={color}>
			<i className={icon}/>
			<DescriptionContent>
				<strong>{title}</strong>
				<p>{description}</p>
			</DescriptionContent>
		</DescriptionBox>
		)
}